import { useQuery } from "@tanstack/react-query";
import { URLS } from "../../../infra/URLS";
import getBotijao from "../queries/getBotijao";

export default function useGetBotijao() {
  const resultQuery = useQuery([`${URLS.BOTIJOES_API}`],
    () => getBotijao());

  return resultQuery;
}
